<script lang="ts">
    import CN from "classnames";

    export let color = "";

    const className = CN("gw-action-item", color && "--customColor");
</script>

<li class={className} style:--custom-color={color}>
    <button class="gw-action-item__btn" on:click>
        {#if $$slots.icon}
            <span class="gw-action-item__icon">
                <slot name="icon" />
            </span>
        {/if}
        <span class="gw-action-item__btn-text">
            <slot />
        </span>
    </button>
</li>

<style>
    .gw-action-item.--customColor .gw-action-item__btn {
        color: var(--custom-color);
    }

    .gw-action-item__btn {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 100%;
        margin: 0;
        padding: 8px;
        border: 0px solid transparent;
        border-radius: var(--gw-border-radius-sm);
        background: none;
        color: inherit;
        color: var(--gw-dark-text-color);
        font-size: 0.9em;
        text-align: center;
        text-decoration: none;
        white-space: nowrap;
        cursor: pointer;
        appearance: none;
    }
    .gw-action-item__btn-text {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .gw-action-item:hover .gw-action-item__btn {
        background: var(--gw-lightgrey-bg);
    }

    .gw-action-item__icon {
        line-height: 0;
        margin-right: 0.3em;
        fill: var(--gw-dark-text-color);
    }
</style>
